import React from 'react'
import css from './style.module.scss'
import { Button } from 'components/ui'
import { Link } from "gatsby"

export default function() {
  return (
    <div className={css.userFinishOrder}>

      <div className={css.title}>
        <h2>Ваша заявка принята</h2>
      </div>

      <p>
        Наш менеджер свяжется с вами в ближайшее время для уточнения деталей заявки.
      </p>

      <div className={css.buttonWrap}>
        <Link to="/" className={css.buttonButton}>
          <Button blue className="form-button" text={'На главную'} />
        </Link>
        <Link to="/donate" className={css.buttonButton}>
          <Button blue ghost text={'Поддержать проект'} />
        </Link>
      </div>

    </div>
  )
}
